import React, { type CSSProperties } from 'react';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import LinearProgress, { type LinearProgressProps } from '@mui/material/LinearProgress';
type SpinnerProps = {
    position?: CSSProperties['position'];
    // colorName?: LinearProgressProps['color'];
    linearProgressProps?: LinearProgressProps;
};

const SpinnerScreenStyled = styled(Grid)<Pick<SpinnerProps, 'position'>>(({ position }) => ({
    position,
    width: '100%',
    height: '100%',
    zIndex: 700,
    top: 0,
    left: 0
}));

const Spinner = React.memo(({ position = 'absolute', linearProgressProps }: SpinnerProps) => (
    <SpinnerScreenStyled
        container
        alignItems="center"
        justifyContent="center"
        position={position}
        role="status"
        aria-live="polite"
        aria-busy="true"
    >
        <Grid
            container
            justifyContent="center"
            alignItems="center"
            sx={{ width: 'fit-content', height: 'fit-content' }}
        >
            <LinearProgress
                role="progressbar"
                aria-label="Loading"
                {...linearProgressProps}
                sx={{ width: 100, ...(linearProgressProps?.sx || {}) }}
            />
        </Grid>
    </SpinnerScreenStyled>
));

export default Spinner;
